<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="职位标签名称"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import {copyObject} from '../../utils/common'
import positionTagApi from '../../api/interview/positionTag'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        sortNumErrors: [],
      },
      showId: false,
      title: '创建职位标签',
      submitButtonStatus: true,
      disabledTypeOption: false,
    }
  },
  created () {
    this.getTag()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    getTag () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.title = '编辑职位标签'
        this.disabledTypeOption = true
        // 通过id获取详情
        positionTagApi.getPositionTag(params.id).then(response => {
          copyObject(response.tag, this.insertData)
          this.tagTypes.forEach(x => {
            if (x.CODE === response.tag.type) {
              this.insertData.type = x.TEXT
            }
          })
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        positionTagApi.updatePositionTag(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('职位标签更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPositionTag' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        positionTagApi.savePositionTag(data).then(response => {
          if (response.success === true) {
            this.showToast('添加职位标签成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPositionTag' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
